module.exports = __webpack_public_path__ + "static/media/Finnovex-West-Africa-2023.4f669278.png";